import api from './api'

export interface DemoCreatePayload {
  first_name: string
  email: string
  language: 'pl' | 'en' | 'de' | 'fr' | 'es' | 'it' | 'pt' | 'cs' | 'hu' | 'nl' | 'fi' | 'da' | 'sv' | 'no' | 'lt' | 'hr' | 'ro'
}

export interface DemoCreateResponse {
  token: string
  token_type: string
  demo_account_id: number
  user: { uuid: string; email: string; demo_email: string; is_demo: boolean }
  club: { uuid: string; name: string; is_demo: boolean }
}

export const createDemoAccount = (payload: DemoCreatePayload) =>
  api.post<DemoCreateResponse>('v1/auth/demo', payload).then(r => r.data)

export const verifyDemoCode = (code: string) =>
  api.post<{ status: string }>('v1/auth/demo/verify', { code }).then(r => r.data)

export const resendDemoCode = () =>
  api.post<{ expires_at: string }>('v1/auth/demo/resend').then(r => r.data)
